module.exports = __webpack_public_path__ + "static/media/bannerPromoMotor.1d705a82.png";